import type { TableFontSchemaType, TableSchemaType } from '@vedalib/editor/lib/brand'
import type { Cell } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import type { FCDemoType } from '../../elements.types'
import Element from './TableElement'

const demoCells: Cell[][] = [
  [
    { value: textToRtValue(t('elements.table.value.cell', { number: 1 })) },
    { value: textToRtValue(t('elements.table.value.cell', { number: 2 })) },
  ],
  [
    { value: textToRtValue(t('elements.table.value.cell', { number: 3 })) },
    { value: textToRtValue(t('elements.table.value.cell', { number: 4 })) },
  ],
]

const demoCellsWithHeader: Cell[][] = [
  [
    { value: textToRtValue(t('elements.table.value.header', { number: 1 })) },
    { value: textToRtValue(t('elements.table.value.header', { number: 2 })) },
  ],
  [
    { value: textToRtValue(t('elements.table.value.header', { number: 3 })) },
    { value: textToRtValue(t('elements.table.value.cell', { number: 1 })) },
  ],
]

const HeadersDemo: FCDemoType<TableSchemaType, TableFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.table.type}-demo`,
        type: CONFIG_ELEMENTS.table.type,
        value: {
          ...CONFIG_ELEMENTS.table.defaultValue,
          headerRow: true,
          headerColumn: true,
          cells: demoCellsWithHeader,
        },
        font: {},
        feedback: {},
        style: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

const DefaultDemo: FCDemoType<TableSchemaType, TableFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.table.type}-demo`,
        type: CONFIG_ELEMENTS.table.type,
        value: { ...CONFIG_ELEMENTS.table.defaultValue, cells: demoCells },
        font: {},
        feedback: {},
        style: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default [DefaultDemo, HeadersDemo]
